import React from 'react';
import { Check } from './fields';

const Competences = ({ data, errors, onChange }) => (
  <>
    <h2>Compétences</h2>
    <p className="section-desc">Cochez ce qui correspond à votre profil.</p>

    <div className="section">
      <h3 className="section-title">Savoir-faire</h3>
      <div className="form-row two-cols">
        <Check name="connaissance_echantillonnage" data={data} onChange={onChange}>
          Méthodes d'échantillonnage
        </Check>
        <Check name="connaissance_controle_qualite" data={data} onChange={onChange}>
          Collecte et contrôle qualité des données
        </Check>
        <Check name="capacite_deploiement_equipes" data={data} onChange={onChange}>
          Déploiement et suivi d'équipes, résolution de difficultés
        </Check>
        <Check name="capacite_verification_donnees" data={data} onChange={onChange}>
          Vérification de la cohérence et de la complétude des données
        </Check>
        <Check name="experience_relations_autorites" data={data} onChange={onChange}>
          Coordination avec les autorités administratives et sanitaires
        </Check>
      </div>
    </div>

    <div className="section">
      <h3 className="section-title">Disponibilité</h3>
      <div className="form-row two-cols">
        <Check name="disponibilite_totale" data={data} onChange={onChange}>
          Disponible de la formation jusqu'à la clôture de l'enquête
        </Check>
        <Check name="apte_deplacements" data={data} onChange={onChange}>
          Apte aux déplacements fréquents, y compris en zones difficiles
        </Check>
      </div>
    </div>

    <div className="section">
      <h3 className="section-title">Engagement <span className="required">*</span></h3>
      <Check name="engagement_ethique" data={data} onChange={onChange} error={errors.engagement_ethique}>
        Je m'engage à travailler avec rigueur et intégrité et à respecter la confidentialité des données.
      </Check>
      {errors.engagement_ethique && <span className="error-message">{errors.engagement_ethique}</span>}
    </div>
  </>
);

export default Competences;
